module.exports = __webpack_public_path__ + "static/img/stator_64.aaf0bd2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/stator_64.png
// module id = cDB+
// module chunks = 0